const selectors = {
  nav: '[data-faq-nav]',
  indicator: '[data-faq-indicator]',
};

const ACTIVE_CLASS = 'bg-yellow';
const INACTIVE_CLASS = 'bg-light-grey';
const SCROLL_OFFSET = 0.25;

export default class MainFaq {
  constructor(section) {
    this.el = section.el;
    this.navItems = [...this.el.querySelectorAll(selectors.nav)];

    if (this.navItems.length === 0) {
      return;
    }

    this.groups = this.navItems
      .map(nav => {
        const id = nav.dataset.faqNav;

        return {
          nav,
          indicator: nav.querySelector(selectors.indicator),
          target: this.el.querySelector(`#${CSS.escape(id)}`),
        };
      })
      .filter(group => group.target && group.indicator);

    if (this.groups.length === 0) {
      return;
    }

    this.activeId = null;
    this.observer = new IntersectionObserver(this._onIntersect.bind(this), {
      rootMargin: '-10% 0px -70% 0px',
      threshold: 0,
    });

    this.groups.forEach(({ target }) => this.observer.observe(target));
    this._updateActive();
  }

  _onIntersect() {
    this._updateActive();
  }

  _updateActive() {
    const offset = window.innerHeight * SCROLL_OFFSET;
    let active = this.groups[0];

    for (const group of this.groups) {
      if (group.target.getBoundingClientRect().top <= offset) {
        active = group;
      }
    }

    const nearBottom =
      window.innerHeight + window.scrollY >=
      document.documentElement.scrollHeight - 2;

    if (nearBottom) {
      active = this.groups[this.groups.length - 1];
    }

    this._setActive(active.target.id);
  }

  _setActive(id) {
    if (this.activeId === id) {
      return;
    }

    this.activeId = id;

    this.groups.forEach(({ indicator, target }) => {
      if (target.id === id) {
        indicator.classList.add(ACTIVE_CLASS);
        indicator.classList.remove(INACTIVE_CLASS);
      } else {
        indicator.classList.remove(ACTIVE_CLASS);
        indicator.classList.add(INACTIVE_CLASS);
      }
    });
  }

  onSectionUnload() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}
